import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "translation/useTranslation";
import { Button, Field, Input, NativeSelect } from "components/ui";

export default function BudgetNormalization({ register, watch, handleSubmit, onSubmit }) {
  const dispatch = useDispatch();

  const { editableTranslate } = useTranslation();

  const [showFloorAmountSettings, setShowFloorAmountSettings] = useState(false);

  const payoutDistributionWatch = watch('payout_distribution');

  useEffect(() => {
    console.log(payoutDistributionWatch);
    if (payoutDistributionWatch) {
      console.log(payoutDistributionWatch);
      if (payoutDistributionWatch === 'floor') {
        setShowFloorAmountSettings(true);
      } else {
        setShowFloorAmountSettings(false);
      }
    }
  }, [payoutDistributionWatch]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="col-md-12">
          <div className="form-row">
            <div className="form-group col-md-3">
              <Field label={editableTranslate('calculation.debugger.budget_amount')}>
                <Input type="number" number {...register('budget_amount')} data-testid="budget-amount-input" />
              </Field>
            </div>
            <div className="form-group col-md-3">
              <Field label={editableTranslate('calculation.debugger.total_fixed_amount')}>
                <Input type="number" number {...register('total_fixed_amount')} data-testid="total-fixed-amount-input" />
              </Field>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label>{editableTranslate('calculation.debugger.payout_distribution')}</label>
              {/* radio buttons: performance-related ony, performance-related and floor, floor only */}
              <div className="form-check">
                <input className="form-check-input" type="radio" value={'performance_related_only'} {...register('payout_distribution')} data-testid="payout-distribution-performance-related-only-radio" />
                <label className="form-check-label ml-1">
                  {editableTranslate('calculation_settings.benefit_distribution_type.performance_related_only')}
                </label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="radio" value={'floor'} {...register('payout_distribution')} data-testid="payout-distribution-floor-radio" />
                <label className="form-check-label ml-1">
                  {editableTranslate('calculation_settings.benefit_distribution_type.floor')}
                </label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="radio" value={'floor_only'} {...register('payout_distribution')} data-testid="payout-distribution-floor-only-radio" />
                <label className="form-check-label ml-1">
                  {editableTranslate('calculation_settings.benefit_distribution_type.floor_only')}
                </label>
              </div>
            </div>
          </div>
          {
            showFloorAmountSettings &&
            <>
              <div className="form-row">
                <div className="form-group col-md-3">
                  <Field label={editableTranslate('calculation.debugger.floor_amount')}>
                    <Input type="number" number {...register('floor_amount')} data-testid="floor-amount-input" />
                  </Field>
                </div>
                <div className="form-group col-md-3">
                  <Field label={editableTranslate('calculation.debugger.floor_type')}>
                    <NativeSelect {...register('floor_type')} data-testid="floor-type-select">
                      <option value={'percent'}>% (percentage)</option>
                      <option value={'amount'}>€ (amount)</option>
                    </NativeSelect>
                  </Field>
                </div>
              </div>
            </>
          }
          <div className="form-row">
            <div className="form-group col-md-6">
              <Button type="submit" variant="primary" data-testid="submit-button">Submit</Button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}